export default __webpack_public_path__ + "static/man-on-phone-drinking-coffee-5ce649aec927513cc1f214e877b0c760.webp";